import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { oauthLogin } from '../../../actions/authActions'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'
import SubmitButton from '../../common/buttons/SubmitButton'

import classes from './OAuthRedirectPage.module.scss'

const OAuthRedirectPage = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const mobile = location.state?.mobile ?? false

  useEffect(() => {
    const code = searchParams.get('code')
    const rawState = searchParams.get('state')

    let parsedState = {}
    try {
      parsedState = rawState ? JSON.parse(rawState) : {}
    } catch {
      parsedState = {}
    }

    if (code) {
      dispatch(oauthLogin(code, parsedState, mobile))
        .then(() => {
          const redirectUrl = localStorage.getItem('redirectUrl') || '/dashboard'
          localStorage.removeItem('communityId')
          localStorage.removeItem('redirectUrl')

          navigate(redirectUrl, { replace: true })
        })
        .catch((err) => {
          setError(err.response?.data || { message: 'An error occurred during OAuth login' })
          setLoading(false)
        })
    } else {
      setError({ message: 'No authorization code provided' })
      setLoading(false)
    }
  }, [searchParams, dispatch, navigate, mobile])

  if (loading) {
    return <Loader />
  }

  if (error) {
    return (
      <div className={classes.authenticationErrorPage}>
        <div className={classes.mainContent}>
          <i className={classNames('fa fa-exclamation-triangle', classes.errorIcon)}/>
          <p className={classes.errorTitle}>{t('auth.oauthRedirect.errorTitle')}</p>
          <p className={classes.errorText}>{t('auth.oauthRedirect.errorText')}</p>
          <div className={classes.errorMessageBox}>
            <p className={classes.errorPrimaryText}>{t('auth.oauthRedirect.needHelp')}</p>
            <p className={classes.errorSecondaryText}>{t('auth.oauthRedirect.supportEmail', { email: 'support@op36golf.com' })}</p>
          </div>
          <div className={classes.mainButton}>
            <SubmitButton onClick={() => navigate('/')} buttonMessage={t('auth.oauthRedirect.backToHome')} />
          </div>
        </div>
      </div>
    )
  }

  return null
}

export default OAuthRedirectPage
